import Styled from 'styled-components';

import SelectInput from './SelectInput';

export interface IGroupProps {
  alert?: boolean;
}

export const FormGroup = Styled.div<IGroupProps>`
  flex: 0 1 100%;

  /* ios9 select/option fix */
  &:last-of-type {
    ${SelectInput} {
      margin-right: 0;
    }
  }
`;

FormGroup.displayName = 'FormGroup';

export default FormGroup;
